
import React, { useEffect, useState } from "react";
import { Brands } from "./Brands";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
export const  BrandsSection = () => {
 const lang = useSelector((state) => state.cart.lang);
      const theme = useSelector((state) => state.cart.theme);
  const [expanded, setExpanded] = useState(false);
  const brands =useSelector((state) => state.cart.brands);
  const [animation,setAnimation] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setAnimation(false)
    }, 500)
        }, []);
    

  return (
    <section dir={lang === 'en' ? 'ltr' :'rtl'} className="min-h-[200px]   mt-[35px] xs:mt-[35px] sm:mt-[50px]  md:mt-[75px] lg:mt-[125px]  xl:mt-[150px] ">
      <div className=" w-full">
        <div  className="flex gap-2  px-10 xl:px-18 lg:px-20 xl:px-24   w-full h-[60px] ">
          <h2 style={{fontFamily:'CairoExtraBold'}} className= {`${lang === 'en' ? 'text-left' :'text-right'} my-auto text-[20px]  lg:text-[50px]  md:text-[40px]  sm:text-[30px]  xs:text-[20px]    w-full `}>
          { lang === 'en' ? 'Pharmacies' :'الصيدليات'} 
          </h2>

          <button
          onClick={()=>{
            
        
              
             setAnimation(true)

             setTimeout(() => {
               setExpanded(!expanded)
             }, 500)
             setTimeout(() => {
               setAnimation(false);
              if(expanded){
                setExpanded(!expanded)
              }
             }, 1000)
            
            
          //  console.log(JSON.stringify(category.products))
           }}
        
           style={{fontFamily:'CairoMedium'}}
            className={` my-auto text-[20px]  lg:text-[40px]  md:text-[30px]  sm:text-[25px]  xs:text-[20px]  ${theme === 'LM' ? 'text-primary' : 'text-primary_ '  } `}
          >
            { lang === 'en' ? 
              expanded ?
             'Less' : 'More'
             :
              expanded ?
             'الغاء' : 'المزيد'}
          </button>
        </div>

     <br />
      
         {expanded ?   
         <>
             <Brands lang={lang} Brands={brands} animation={animation} />
            
       
             </>
          :
          <div style={{overflowX:'auto'}} className={`${theme === 'LM' ? 'light-scrollbar' : 'dark-scrollbar' } ${animation ? `transition-all  duration-500 ${lang === 'en' ? '-translate-x-[100%]' :'translate-x-[100%]'} opacity-[0]` :  'transition-all duration-500 translate-x-[0] opacity-[1]'  } m-auto w-full flex gap-3 p-1 py-3 items-center`} >
            {brands.map((item, index) => (
              <Link
              to={`brand/${item.id}`}
                key={index}
                className={` ${theme === 'LM' ? 'bg-[#ffffff]  hover:bg-[#f1f1f1] shadow-black/30 ' : 'bg-[#1a1a1a] shadow-white/30  hover:bg-zinc-800'  } shadow-md  m-auto flex  rounded-[7px]  h-[75px] w-[150px] min-h-[75px] min-w-[150px]  
                lg:w-[300px] lg:h-[150px] xl:w-[350px] xl:h-[175px] md:h-[100px] md:w-[200px]
                lg:min-w-[300px] lg:min-h-[150px] xl:min-w-[350px] xl:min-h-[175px] md:min-h-[100px] md:min-w-[200px]`} 
              >
                <img
                 src={`https://dev.dawasmart.com/img/${item.src}`}
                  alt={`${item.alt}`}
                  className="object-contain m-auto w-full max-h-[65px] lg:w-[240px] lg:max-h-[115px] xl:w-[290px] xl:max-h-[145px]  md:h-[90px] md:w-[190px]"
                />
              </Link>
            ))}
          </div>

          }
 <div className="z-2 relative w-full mt-4">
          <Link to={'Pharmacies'} style={{fontFamily:'CairoBold'}} className={`${theme === 'LM' ? 'text-primary' : 'text-primary_ '  } mx-auto`}  >
          { lang === 'en' ? 'View All Pharmacies' : 'عرض كل الصيدليات'}
          </Link>
          </div> 

        </div>
    
     
    </section>
  );
}
